import { Box, Paper, Typography } from "@mui/material";
import React from "react";

interface LegendItem {
  label: string;
  color: string;
  types: string[];
}

const LEGEND_ITEMS: LegendItem[] = [
  {
    label: "Manufacturing",
    color: "rgb(0, 204, 255)", // Neon cyan
    types: [
      "factory",
      "facility_complex",
      "production_line",
      "refinery",
      "recycling",
    ],
  },
  {
    label: "Warehouse",
    color: "rgb(255, 102, 0)", // Neon orange
    types: ["warehouse"],
  },
  {
    label: "Distribution Center",
    color: "rgb(153, 0, 255)", // Neon purple
    types: ["distribution_center"],
  },
  {
    label: "Service Center",
    color: "rgb(204, 51, 204)", // Light purple
    types: ["service_center"],
  },
  {
    label: "Store",
    color: "rgb(255, 0, 128)", // Neon pink
    types: ["store"],
  },
  {
    label: "Office",
    color: "rgb(0, 255, 102)", // Neon green
    types: ["office"],
  },
  {
    label: "Exhibition",
    color: "rgb(255, 153, 204)", // Light pink
    types: ["exhibition_booth"],
  },
  {
    label: "Technology",
    color: "rgb(255, 255, 0)", // Neon yellow
    types: ["research_and_development", "data_center"],
  },
  {
    label: "Transportation",
    color: "rgb(0, 153, 255)", // Bright blue
    types: ["port_or_harbor", "airport", "rail_or_rail_station"],
  },
  {
    label: "Extractive",
    color: "rgb(204, 102, 0)", // Brown-orange
    types: ["mine", "oil_rig"],
  },
  {
    label: "Energy",
    color: "rgb(255, 51, 51)", // Bright red
    types: ["power_plant"],
  },
  {
    label: "Military",
    color: "rgb(51, 128, 51)", // Dark green
    types: ["military"],
  },
  {
    label: "Other",
    color: "rgb(128, 128, 128)", // Gray
    types: ["other"],
  },
];

const MapLegend: React.FC = () => {
  return (
    <Paper
      sx={{
        position: "absolute",
        bottom: 16,
        left: 16,
        zIndex: 1000,
        backgroundColor: "rgba(30, 30, 30, 0.95)",
        backdropFilter: "blur(8px)",
        padding: 2,
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
        minWidth: 180,
        maxWidth: 220,
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(255, 255, 255, 0.2)",
          borderRadius: "3px",
          "&:hover": {
            background: "rgba(255, 255, 255, 0.3)",
          },
        },
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: "#ffffff",
          fontWeight: 600,
          marginBottom: 1.5,
          fontSize: "13px",
          letterSpacing: "0.5px",
          textTransform: "uppercase",
        }}
      >
        Facility Types
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
        {LEGEND_ITEMS.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: item.color,
                flexShrink: 0,
                boxShadow: `0 0 8px ${item.color}80`,
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#e0e0e0",
                fontSize: "12px",
                lineHeight: 1.3,
              }}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default MapLegend;
